import React, { useState } from 'react'
import { Table, Divider, Row, Col, List, Tag } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import {
  loadIsSalePanelActive,
  loadIsPaymentPanelActionCompleteActive,
  loadIsPaymentPanelLoading,
  loadIsMainLoading
} from '../../appRedux/actions/MainSale'
import IntlMessages from '../../util/IntlMessages'
import CustomScrollbars from '../../util/CustomScrollbars'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { calculateSavings } from '../../appRedux/actions/ProdHelperMethods'
import {
  customParse,
  formatDigits,
  parseFloatCustom
} from '../../appRedux/actions'
import PaymentPanelSummaryHelper_1 from './PaymentPanelSummaryHelper_1'

const PaymentPanelSummary = props => {
  const dispatch = useDispatch()
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getTableDataSellTax = useSelector(
    ({ MainSale }) => MainSale.getTableDataSellTax
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const getTableDataSaleProduct = useSelector(
    ({ MainSale }) => MainSale.getTableDataSaleProduct
  )
  const getIsDiscountRowVisible = useSelector(
    ({ MainSale }) => MainSale.getIsDiscountRowVisible
  )
  const getDiscountPriceTotal = useSelector(
    ({ MainSale }) => MainSale.getDiscountPriceTotal
  )
  const getIsPaymentPanelActionCompleteActive = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPanelActionCompleteActive
  )
  const getTableDataSellPromotion = useSelector(
    ({ MainSale }) => MainSale.getTableDataSellPromotion
  )
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const enableTaxCode = useSelector(({ MainSale }) => MainSale.enableTaxCode)

  // const [getSavings, setSavings] = React.useState("");

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      calculateSavings(
        getReduxSaleProductJsonData,
        getTableDataSellPromotion,
        getDiscountPriceTotal,
        getDefaultDecimalPlaces,
        getIsRefundSale,
        dispatch
      )
    }

    return () => (mounted = false)
  }, [getTableDataSellPromotion, getDiscountPriceTotal])

  const handleSalePanelActive = isPaymentPanelActive => {
    dispatch(loadIsSalePanelActive(isPaymentPanelActive))
    dispatch(loadIsPaymentPanelActionCompleteActive(false))
    if (!isPaymentPanelActive) {
      dispatch(loadIsPaymentPanelLoading(true))
      dispatch(loadIsMainLoading(true))
    }
  }

  const columnsSaleProductList = [
    {
      title: 'Quantity',
      dataIndex: 'Quantity',
      key: 'Quantity',
      render: (text, record) => (
        <p className='custom-font-color-black'>{record.Quantity}</p>
      )
    },
    {
      title: 'ProductDetail',
      dataIndex: 'ProductDetail',
      key: 'ProductDetail',
      render: (text, record) => (
        <div className='td-cell-summary'>
          <p className='custom-font-color-black custom-mg-bt-0'>
            {record.ProductName}
          </p>
          {record.VariantName && (
            <div className='dk-text-supplementary'>{record.VariantName}</div>
          )}

          {record.PromotionID != '' ? (
            <div className='dk-text-supplementary'>
              <i className='icon icon-tickets custom-pd-right-4' />
              <span>
                {record.PromotionName != '' ? record.PromotionName : ''}
              </span>{' '}
            </div>
          ) : (
            ''
          )}

          {record.ProductNotes && (
            <div className='dk-text-supplementary custom-mg-top-10'>
              {' '}
              {record.ProductNotes ? (
                <IntlMessages id='sell.sell.note' />
              ) : (
                ''
              )}{' '}
              {record.ProductNotes}
            </div>
          )}
        </div>
      )
    },
    {
      title: 'ProductPrices',
      dataIndex: 'ProductPrices',
      key: 'ProductPrices',
      render: (text, record) => (
        <div className={`sell-product-text float-right`}>
          {record.LineItemTotalBasePrice && (
            <span>
              {record.LineItemTotalBasePrice}
              {enableTaxCode && record.TaxCode ? ` ${record.TaxCode}` : ''}
            </span>
          )}
          {record.LineItemTotalPrice && (
            <div className='gx-manage-margin sell-promotion-text'>
              <span className='gx-text-muted gx-px-2'>
                {' '}
                <del>{record.LineItemTotalPrice}</del>
              </span>
            </div>
          )}
        </div>
      )
    }
  ]

  function evenOrOdd (num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return 'even'
    } else {
      return 'odd'
    }
  }

  return (
    <>
      <div className='sale-wrapper-bg div-flow'>
        <div className='d-flex align-items-center justify-content-between mb-3'>
          <h1 className='custom-font-weight-500  dk-text-hero gx-mb-0 custom-font-color-black'>
            {!getIsPaymentPanelActionCompleteActive && (
              <ArrowLeftOutlined
                onClick={e => handleSalePanelActive(true)}
                className='dk-vertical-base-align'
              />
            )}
            <span>
              <IntlMessages id='sell.sell.sale' />
            </span>
          </h1>

          <div className='reservation-tags PayScreen-tags'>
            {sellSelAttributes &&
              sellSelAttributes.length > 0 &&
              sellSelAttributes.map((as, io) => {
                const isEvenOrOdd = evenOrOdd(io)
                return (
                  <Tag
                    color={isEvenOrOdd == 'even' ? '#2db7f5' : '#87d068'}
                    key={io}
                  >
                    {as.groupName ? `${as.groupName}: ` : ''}
                    {as.attributeName ? `${as.attributeName}` : ''}
                  </Tag>
                )
              })}
          </div>
        </div>

        <div className='sale-wrapper-div'>
          <div className='SaleProductList-div div-flow theme-scroll'>
            <Table
              className='gx-table-responsive custom-product-sale-list-table'
              columns={columnsSaleProductList}
              dataSource={getTableDataSaleProduct}
              pagination={false}
            />
          </div>

          <div className='SaleProduct-Total-div div-flow'>
            <div className='dk-payment-panel-summary-flex'>
              <div className='dk-payment-panel-summary-flex-child'>
                <div className='dk-sell-summary-line'>
                  <IntlMessages id='sell.sell.subtotal' />
                </div>
                <div className='dk-sell-summary-line'>
                  {getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol}{' '}
                  {getSaleOrderJson.TotalPrice
                    ? `${formatDigits(
                        customParse(getSaleOrderJson.TotalPrice) +
                          (getSaleOrderJson.SalesOrderDiscountPrice
                            ? customParse(
                                getSaleOrderJson.SalesOrderDiscountPrice
                              )
                            : 0) -
                          customParse(getSaleOrderJson.TotalTax),
                        getDefaultDecimalPlaces
                      )}`
                    : ''}
                </div>
              </div>

              {getIsDiscountRowVisible && (
                <div className='dk-payment-panel-summary-flex-child'>
                  <div className='dk-sell-summary-line'>
                    <IntlMessages id='sell.salehistory.adddis' />
                  </div>
                  <div className='dk-sell-summary-line'>
                    {getDiscountPriceTotal ? (
                      <>
                        {`${getCurrData.currencyCode} ${
                          getIsRefundSale ? '' : '-'
                        }${formatDigits(
                          getDiscountPriceTotal,
                          getDefaultDecimalPlaces
                        )}`}
                      </>
                    ) : (
                      <>{`${getCurrData.currencyCode} 0.00`}</>
                    )}
                  </div>
                </div>
              )}
              <div className='dk-payment-panel-summary-flex-child'>
                <div className='dk-sell-summary-line'>
                  <IntlMessages id='sell.sell.tax' /> (
                  {getTableDataSellTax &&
                  getTableDataSellTax.length &&
                  getTableDataSellTax.length > 0
                    ? getTableDataSellTax.length
                    : 'No Tax)'}{' '}
                  {getTableDataSellTax && getTableDataSellTax.length > 1 && (
                    <>
                      <IntlMessages id='sell.sell.taxes' />)
                    </>
                  )}
                  {getTableDataSellTax && getTableDataSellTax.length == 1 && (
                    <>
                      <IntlMessages id='sell.sell.tax' />)
                    </>
                  )}
                </div>
                <div className='dk-sell-summary-line'>
                  {getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol}{' '}
                  {getTableDataSellTax && getTableDataSellTax != undefined
                    ? formatDigits(
                        getTableDataSellTax.reduce(
                          (a, v) => (a = a + v.sellTaxPrice),
                          0
                        ),
                        getDefaultDecimalPlaces
                      )
                    : '0.00'}
                </div>
              </div>

              {getTableDataSellTax && getTableDataSellTax.length > 0 && (
                <div className='dk-mg-lft'>
                  <List
                    dataSource={getTableDataSellTax}
                    renderItem={item => {
                      let taxRate = item.sellTaxRate * 100
                      return (
                        <List.Item
                          key={item.key}
                          className='custom-ant-sale-list'
                        >
                          <List.Item.Meta
                            title={`${item.sellTaxName}  ${
                              item.isFix ? item.fixRate : taxRate
                            }
                          ${item.isFix ? ' FIX' : '%'}`}
                          />
                          <div>
                            {getCurrData.currencyCode != null
                              ? getCurrData.currencyCode
                              : getCurrData.currencyName != null
                              ? getCurrData.currencyName
                              : getCurrData.currencySymbol}{' '}
                            {formatDigits(
                              item.sellTaxPrice,
                              getDefaultDecimalPlaces
                            )}
                          </div>
                        </List.Item>
                      )
                    }}
                  ></List>
                </div>
              )}

              <PaymentPanelSummaryHelper_1 getCurrData={getCurrData} />
            </div>
          </div>
        </div>
      </div>
    </>
  )

  // return (
  //   <>
  //     <h1 className="custom-font-weight-500  dk-text-hero gx-mb-0 custom-font-color-black">
  //       {!getIsPaymentPanelActionCompleteActive && (
  //         <ArrowLeftOutlined
  //           onClick={(e) => handleSalePanelActive(true)}
  //           className="dk-vertical-base-align"
  //         />
  //       )}
  //       <span style={{ marginLeft: 4, marginRight: 14 }}>
  //         <IntlMessages id="sell.sell.sale" />
  //       </span>
  //       {sellSelAttributes && sellSelAttributes.length > 0 &&
  //         sellSelAttributes.map((as, io) => {
  //           const isEvenOrOdd = evenOrOdd(io);
  //           return (
  //             <Tag
  //               color={isEvenOrOdd == "even" ? "#2db7f5" : "#87d068"}
  //               key={io}
  //             >
  //               {as.groupName ? `${as.groupName}: ` : ""}
  //               {as.attributeName ? `${as.attributeName}` : ""}
  //             </Tag>
  //           )
  //         })}
  //     </h1>
  //     <CustomScrollbars className="gx-module-content-scroll fixed">
  //       <div className="dk-payment-panel-summary">
  //         <Table
  //           className="gx-table-responsive custom-product-sale-list-table"
  //           columns={columnsSaleProductList}
  //           dataSource={getTableDataSaleProduct}
  //           pagination={false}
  //         />
  //         <Divider className="custom-promolist-divider" />

  //         <div className="dk-payment-panel-summary-flex">
  //           <div className="dk-payment-panel-summary-flex-child">
  //             <div className="dk-sell-summary-line">
  //               <IntlMessages id="sell.sell.subtotal" />
  //             </div>
  //             <div className="dk-sell-summary-line">
  //               {getCurrData.currencyCode != null
  //                 ? getCurrData.currencyCode
  //                 : getCurrData.currencyName != null
  //                   ? getCurrData.currencyName
  //                   : getCurrData.currencySymbol}{" "}
  //               {getSaleOrderJson.TotalPrice
  //                 ? `${formatDigits(
  //                   customParse(getSaleOrderJson.TotalPrice) +
  //                   (getSaleOrderJson.SalesOrderDiscountPrice ?
  //                     customParse(getSaleOrderJson.SalesOrderDiscountPrice) : 0) - customParse(getSaleOrderJson.TotalTax),
  //                   getDefaultDecimalPlaces
  //                 )}`
  //                 : ""}
  //               {/* {getSaleOrderJson &&
  //                   getSaleOrderJson.finals &&
  //                   getSaleOrderJson.finals.exc != undefined
  //                   ? formatDigits(getIsDiscountRowVisible && getDiscountPriceTotal ?
  //                     (parseFloatCustom(getSaleOrderJson.finals.exc) + parseFloatCustom(getDiscountPriceTotal)) :
  //                     getSaleOrderJson.finals.exc
  //                     , getDefaultDecimalPlaces)
  //                   : " "} */}
  //             </div>
  //           </div>
  //           {/* {getIsTaxExclusive && (
  //             <div className="dk-payment-panel-summary-flex-child">
  //               <div className="dk-sell-summary-line">
  //                 <IntlMessages id="sell.sell.subtotal" />
  //               </div>
  //               <div className="dk-sell-summary-line">
  //                 {getCurrData.currencyCode != null
  //                   ? getCurrData.currencyCode
  //                   : getCurrData.currencyName != null
  //                     ? getCurrData.currencyName
  //                     : getCurrData.currencySymbol}{" "}
  //                 {getSaleOrderJson &&
  //                   getSaleOrderJson.finals &&
  //                   getSaleOrderJson.finals.exc != undefined
  //                   ? formatDigits(getSaleOrderJson.finals.subtotal, getDefaultDecimalPlaces)
  //                   : " "}
  //               </div>
  //             </div>
  //           )} */}
  //           {getIsDiscountRowVisible && (
  //             <div className="dk-payment-panel-summary-flex-child">
  //               <div className="dk-sell-summary-line">
  //                 <IntlMessages id="sell.salehistory.adddis" />
  //               </div>
  //               <div className="dk-sell-summary-line">
  //                 {getDiscountPriceTotal ? (
  //                   <>
  //                     {`${getCurrData.currencyCode} ${getIsRefundSale ? "" : "-"}${formatDigits(getDiscountPriceTotal, getDefaultDecimalPlaces)}`}
  //                   </>
  //                 ) : (
  //                   <>{`${getCurrData.currencyCode} 0.00`}</>
  //                 )}
  //               </div>
  //             </div>
  //           )}
  //           {/* {!getIsTaxExclusive && (
  //             <div className="dk-payment-panel-summary-flex-child">
  //               <div className="dk-sell-summary-line">
  //                 <IntlMessages id="sell.sell.subtotal" />
  //               </div>
  //               <div className="dk-sell-summary-line">
  //                 {getCurrData.currencyCode != null
  //                   ? getCurrData.currencyCode
  //                   : getCurrData.currencyName != null
  //                     ? getCurrData.currencyName
  //                     : getCurrData.currencySymbol}{" "}
  //                 {getSaleOrderJson &&
  //                   getSaleOrderJson.finals &&
  //                   getSaleOrderJson.finals.exc != undefined
  //                   ? formatDigits(getSaleOrderJson.finals.exc, getDefaultDecimalPlaces)
  //                   : " "}
  //               </div>
  //             </div>
  //           )} */}
  //           <div className="dk-payment-panel-summary-flex-child">
  //             <div className="dk-sell-summary-line">
  //               <IntlMessages id="sell.sell.tax" /> (
  //               {getTableDataSellTax &&
  //                 getTableDataSellTax.length &&
  //                 getTableDataSellTax.length > 0
  //                 ? getTableDataSellTax.length
  //                 : "No Tax)"}{" "}
  //               {getTableDataSellTax && getTableDataSellTax.length > 1 && (
  //                 <>
  //                   <IntlMessages id="sell.sell.taxes" />)
  //                 </>
  //               )}
  //               {getTableDataSellTax && getTableDataSellTax.length == 1 && (
  //                 <>
  //                   <IntlMessages id="sell.sell.tax" />)
  //                 </>
  //               )}
  //             </div>
  //             <div className="dk-sell-summary-line">
  //               {getCurrData.currencyCode != null
  //                 ? getCurrData.currencyCode
  //                 : getCurrData.currencyName != null
  //                   ? getCurrData.currencyName
  //                   : getCurrData.currencySymbol}{" "}
  //               {getTableDataSellTax && getTableDataSellTax != undefined
  //                 ? formatDigits(
  //                   getTableDataSellTax
  //                     .reduce((a, v) => (a = a + v.sellTaxPrice), 0),
  //                   getDefaultDecimalPlaces
  //                 )
  //                 : "0.00"}
  //             </div>
  //           </div>

  //           {getTableDataSellTax && getTableDataSellTax.length > 0 && (
  //             <div className="dk-mg-lft">
  //               <List
  //                 dataSource={getTableDataSellTax}
  //                 renderItem={(item) => {
  //                   let taxRate = item.sellTaxRate * 100;
  //                   return (
  //                     <List.Item key={item.key} className="custom-ant-sale-list">
  //                       <List.Item.Meta
  //                         title={`${item.sellTaxName}  ${item.isFix ? item.fixRate : taxRate}
  //                         ${item.isFix ? " FIX" : "%"}`}
  //                       />
  //                       <div>
  //                         {getCurrData.currencyCode != null
  //                           ? getCurrData.currencyCode
  //                           : getCurrData.currencyName != null
  //                             ? getCurrData.currencyName
  //                             : getCurrData.currencySymbol}{" "}
  //                         {formatDigits(item.sellTaxPrice, getDefaultDecimalPlaces)}
  //                       </div>
  //                     </List.Item>
  //                   );
  //                 }}
  //               ></List>
  //             </div>
  //           )}

  //           <Divider className="custom-promolist-divider" />
  //           <div className="dk-payment-panel-summary-flex-child">
  //             <div className="dk-sell-summary-line">
  //               <strong>
  //                 <IntlMessages id="sell.sell.saletotal" />
  //               </strong>
  //               {getSaleOrderJson && getSaleOrderJson.totalItems && (
  //                 <span className="dk-text--sub">
  //                   {` ${getSaleOrderJson.totalItems} `}
  //                   {getSaleOrderJson.totalItems > 1 ? (
  //                     <IntlMessages id="sell.sell.items" />
  //                   ) : (
  //                     <IntlMessages id="sell.sell.item" />
  //                   )}
  //                 </span>
  //               )}
  //             </div>
  //             <div className="dk-sell-summary-line">
  //               {getCurrData.currencyCode != null
  //                 ? getCurrData.currencyCode
  //                 : getCurrData.currencyName != null
  //                   ? getCurrData.currencyName
  //                   : getCurrData.currencySymbol}{" "}
  //               {getSaleOrderJson != undefined &&
  //                 getSaleOrderJson.finals != undefined
  //                 ? getSaleOrderJson.finals.inc != undefined
  //                   ? formatDigits(getSaleOrderJson.finals.inc, getDefaultDecimalPlaces)
  //                   : " "
  //                 : ""}
  //             </div>
  //           </div>
  //           <Divider className="custom-promolist-divider" />
  //           <div className="dk-mg-lft no-mar-left">
  //             {getSalePayments &&
  //               getSalePayments.map((paymentObject, index) => {
  //                 return (
  //                   <div className="custom-mg-bt" key={index}>
  //                     <div className="dk-payment-panel-summary-flex-child">
  //                       <div className="dk-sell-summary-line">
  //                         <div className=" dk-sell-summary-linedk-mg-btm-auto">
  //                           {paymentObject.paymentName}
  //                         </div>

  //                         <div className="dk-text-supplementary">
  //                           {paymentObject.paymentDate}
  //                         </div>
  //                       </div>
  //                       <div className="dk-sell-summary-line">
  //                         {getCurrData.currencyCode != null
  //                           ? getCurrData.currencyCode
  //                           : getCurrData.currencyName != null
  //                             ? getCurrData.currencyName
  //                             : getCurrData.currencySymbol}{" "}
  //                         {formatDigits(paymentObject.amount, getDefaultDecimalPlaces)}
  //                       </div>
  //                     </div>
  //                   </div>
  //                 );
  //               })}
  //             <Divider className="custom-promolist-divider" />
  //             {getSaleOrderJson.Change != undefined &&
  //               getSaleOrderJson.Change > 0 ? (
  //               <>
  //                 <div className="dk-payment-panel-summary-flex-child">
  //                   <div className="dk-sell-summary-line">
  //                     <strong>
  //                       <IntlMessages id="sell.sell.change" />
  //                     </strong>
  //                   </div>
  //                   <div className="dk-sell-summary-line">
  //                     {getCurrData.currencyCode != null
  //                       ? getCurrData.currencyCode
  //                       : getCurrData.currencyName != null
  //                         ? getCurrData.currencyName
  //                         : getCurrData.currencySymbol}{" "}
  //                     {formatDigits(getSaleOrderJson.Change, getDefaultDecimalPlaces)}
  //                   </div>
  //                 </div>
  //               </>
  //             ) : (
  //               ""
  //             )}

  //             <div className="dk-payment-panel-summary-flex-child">
  //               <div className="dk-sell-summary-line">
  //                 <strong>
  //                   <IntlMessages id="sell.sell.topay" />
  //                 </strong>
  //               </div>
  //               <div className="dk-sell-summary-line">
  //                 {getCurrData.currencyCode != null
  //                   ? getCurrData.currencyCode
  //                   : getCurrData.currencyName != null
  //                     ? getCurrData.currencyName
  //                     : getCurrData.currencySymbol}{" "}
  //                 {formatDigits(getSaleOrderJson.AmountToPay, getDefaultDecimalPlaces)}
  //               </div>
  //             </div>
  //             {getSaleOrderJson && getSaleOrderJson.Notes && (
  //               <>
  //                 <Divider className="custom-promolist-divider" />
  //                 <div className="">
  //                   <IntlMessages id="sell.sell.note" />
  //                   {` ${getSaleOrderJson.Notes}`}
  //                 </div>
  //               </>
  //             )}
  //           </div>
  //           <Divider className="custom-promolist-divider" />
  //           {getSavings != "" && (
  //             <div className="dk-payment-panel-summary-flex-child">
  //               <div className="dk-sell-summary-line">
  //                 <strong>
  //                   <IntlMessages id="sell.sell.totalsavings" />
  //                 </strong>
  //               </div>
  //               <div className="dk-sell-summary-line">
  //                 {getCurrData.currencyCode != null
  //                   ? getCurrData.currencyCode
  //                   : getCurrData.currencyName != null
  //                     ? getCurrData.currencyName
  //                     : getCurrData.currencySymbol}
  //                 {` ${getSavings}`}
  //               </div>
  //             </div>
  //           )}
  //           <Divider className="custom-promolist-divider" />
  //         </div>
  //       </div>
  //     </CustomScrollbars>
  //   </>
  // );
}

export default PaymentPanelSummary

{
  /* <Row>
                <Col span={16}>
                  {getSaleOrderJson.TotalSavings != 0 ? (
                    <h3>
                      <strong>
                        <IntlMessages id="sell.sell.totalsavings" />
                      </strong>
                    </h3>
                  ) : (
                    ""
                  )}
                </Col>

                <Col span={8}>
                  <h3 style={{ float: "right" }}>
                    {" "}
                    {getSaleOrderJson.TotalSavings != 0
                      ? getCurrData.currencyCode != null
                        ? getCurrData.currencyCode
                        : getCurrData.currencyName != null
                          ? getCurrData.currencyName
                          : getCurrData.currencySymbol
                      : ""}
                    {" "}
                    {getSaleOrderJson.TotalSavings != 0
                      ? parseFloat(getSaleOrderJson.TotalSavings).toFixed(getDefaultDecimalPlaces)
                      : ""}
                  </h3>
                </Col>
              </Row> */
}
